import { m as e } from "./image.service-BZ-WQOP-.js";
import { Fragment as t, computed as n, createBlock as r, createCommentVNode as i, createElementBlock as a, createElementVNode as o, createTextVNode as s, createVNode as c, defineComponent as l, openBlock as u, toDisplayString as d, unref as f, withCtx as p } from "vue";
import { QTooltip as m } from "quasar";
import { useI18n as h } from "vue-i18n";
import { StatusIcon as g } from "@editor/ui-layout";
//#region src/components/editor-image-placeholder.vue
var _ = {}, v = { class: "flex flex-center placeholder" };
function y(e, t) {
	return u(), a("div", v);
}
var b = /* @__PURE__ */ e(_, [["render", y], ["__scopeId", "data-v-6c593e06"]]), x = (e) => {
	let t = e ? e.getTime() : 1;
	return Math.ceil((t - Date.now()) / (1e3 * 60 * 60 * 24));
}, S = {
	key: 0,
	class: "absolute-full flex flex-center"
}, C = { class: "relative-center text-subtitle2 image-overlay-label text-dark" }, w = ["textContent"], T = {
	key: 1,
	class: "absolute-top-left text-subtitle2 image-overlay-label q-ml-xs q-mt-xs text-dark"
}, E = ["textContent"], D = {
	key: 2,
	class: "absolute-top-left text-subtitle2 image-overlay-label q-ml-xs q-mt-xs text-dark"
}, O = ["textContent"], k = {
	key: 3,
	class: "absolute-full flex flex-center"
}, A = { class: "relative-center text-subtitle2 image-overlay-label text-dark" }, j = ["textContent"], M = /* @__PURE__ */ e(/* @__PURE__ */ l({
	__name: "editor-image-state-overlay",
	props: {
		image: {},
		entity: { default: void 0 },
		showMsgInTooltip: {
			type: Boolean,
			default: !1
		}
	},
	setup(e) {
		let { t: l } = h(), _ = e, v = n(() => x(_.image.publishDate)), y = n(() => x(_.image.unpublishDate));
		return (n, h) => (u(), a(t, null, [
			e.image.state === "draft" && e.entity !== "video" ? (u(), a("div", S, [o("div", C, [c(f(g), {
				value: "edit-3",
				class: "image-overlay-icon text-grey"
			}), e.showMsgInTooltip ? (u(), r(f(m), {
				key: 0,
				anchor: "top middle",
				self: "bottom middle",
				class: "text-white bg-black",
				offset: [5, 5]
			}, {
				default: p(() => [s(d(f(l)("images.components.imageDraft")), 1)]),
				_: 1
			})) : (u(), a("span", {
				key: 1,
				class: "q-ml-xs",
				textContent: d(f(l)("images.components.imageDraft"))
			}, null, 8, w))])])) : i("", !0),
			e.image.state === "schedule" && e.entity !== "video" ? (u(), a("div", T, [c(f(g), {
				value: "clock",
				class: "image-overlay-icon text-light-blue"
			}), e.showMsgInTooltip ? (u(), r(f(m), {
				key: 0,
				anchor: "top middle",
				self: "bottom middle",
				class: "text-white bg-black",
				offset: [5, 5]
			}, {
				default: p(() => [s(d(f(l)("images.components.imagePublish", { n: v.value })), 1)]),
				_: 1
			})) : (u(), a("span", {
				key: 1,
				class: "q-ml-xs",
				textContent: d(f(l)("components.imagePublish", { n: v.value }))
			}, null, 8, E))])) : i("", !0),
			e.image.state === "publish" && e.image.unpublishDate && e.entity !== "video" ? (u(), a("div", D, [c(f(g), {
				value: "clock",
				class: "image-overlay-icon text-red"
			}), e.showMsgInTooltip ? (u(), r(f(m), {
				key: 0,
				anchor: "top middle",
				self: "bottom middle",
				class: "text-white bg-black",
				offset: [5, 5]
			}, {
				default: p(() => [s(d(f(l)("images.components.imageExpiresIn", { n: y.value })), 1)]),
				_: 1
			})) : (u(), a("span", {
				key: 1,
				class: "q-ml-xs",
				textContent: d(f(l)("components.imageExpiresIn", { n: y.value }))
			}, null, 8, O))])) : i("", !0),
			e.image.state === "unpublish" && e.entity !== "video" ? (u(), a("div", k, [o("div", A, [c(f(g), {
				value: "alert-circle",
				class: "image-overlay-icon text-red"
			}), e.showMsgInTooltip ? (u(), r(f(m), {
				key: 0,
				anchor: "top middle",
				self: "bottom middle",
				class: "text-white bg-black",
				offset: [5, 5]
			}, {
				default: p(() => [s(d(f(l)("images.components.imageExpired")), 1)]),
				_: 1
			})) : (u(), a("span", {
				key: 1,
				class: "q-ml-xs",
				textContent: d(f(l)("images.components.imageExpired"))
			}, null, 8, j))])])) : i("", !0)
		], 64));
	}
}), [["__scopeId", "data-v-fca9e474"]]);
//#endregion
export { x as n, b as r, M as t };

//# sourceMappingURL=editor-image-state-overlay-BPFTeb65.js.map